class EventsHandler {
  constructor() {
    this._mouseTarget = null
    this._mouseButton = null
    this._ctrlKey = false
    this._altKey = false
    this._shiftKey = false
    this._dragTolerance = 2
    this._dragStartX = null
    this._dragStartY = null
    this._dragData = null

    this._handlers = {}
  }

  bind(event) {
    document.addEventListener(event, this.handle)
  }

  unbind() {
    document.removeEventListener('keydown', this.handle)
    document.removeEventListener('keyup', this.handle)
    document.removeEventListener('mousedown', this.handle)
    document.removeEventListener('mouseup', this.handle)
    document.removeEventListener('mousemove', this.handle)
    document.removeEventListener('contextmenu', this.handle)
    document.removeEventListener('mouseenter', this.handle)
    document.removeEventListener('mouseleave', this.handle)
  }

  handle = (e, data = null) => {
    if (e.__handled || (e.type !== 'contextmenu' && !this.enabled())) {
      return
    }

    e.__handled = true

    const handler = {
      keydown: this._onKeyDown,
      keyup: this._onKeyUp,
      mousedown: this._onMouseDown,
      mouseup: this._onMouseUp,
      mousemove: this._onMouseMove,
      contextmenu: this._onContextMenu,
      mouseenter: this._onMouseEnter,
      mouseleave: this._onMouseLeave,
    }[e.type]

    handler(e, data)
  }

  on(element, event, handler) {
    if (!this._handlers[event]) {
      this._handlers[event] = []
    }
    this._handlers[event].push({ element, handler })
  }

  un(element, event, handler) {
    if (this._handlers[event]) {
      for (let key in this._handlers) {
        if (
          this._handlers[event][key].element === element &&
          this._handlers[event][key].handler === handler
        ) {
          delete this._handlers[event][key]
          break
        }
      }
    }
  }

  enabled() {
    return true
  }

  _raise(event, e, additionalEventParams = {}, data = {}) {
    if (this._handlers[event]) {
      const eventObj = Object.assign(
        {
          ctrlKey: this._ctrlKey,
          shiftKey: this._shiftKey,
          altKey: this._altKey,
          mouseButton: this._mouseButton,
          stopped: false,
          event: e,
          stop: function () {
            this.stopped = true
          },
        },
        additionalEventParams,
        { data }
      )

      for (let key in this._handlers[event]) {
        if (
          this._handlers[event][key].element === null ||
          this._handlers[event][key].element === e.target
        ) {
          this._handlers[event][key].handler(eventObj)
          if (eventObj.stopped) {
            break
          }
        }
      }
    }
  }

  _onKeyDown = (e, data) => {
    this._altKey = e.altKey
    this._ctrlKey = e.ctrlKey
    this._shiftKey = e.shiftKey

    this._raise('keydown', e, {}, data)
  }

  _onKeyUp = (e, data) => {
    this._altKey = e.altKey
    this._ctrlKey = e.ctrlKey
    this._shiftKey = e.shiftKey

    this._raise('keyup', e, {}, data)
  }

  _onMouseEnter = (e, data) => {
    this._raise('mouseenter', e, {}, data)
  }

  _onMouseLeave = (e, data) => {
    this._raise('mouseleave', e, {}, data)
  }

  _onMouseDown = (e, data) => {
    this._mouseTarget = e.target
    this._mouseButton = e.button
    this._dragData = data

    this._raise('mousedown', e, {}, data)
  }

  _onMouseUp = (e, data) => {
    if (this._dragEvent) {
      this._raise('dragend', e, this._dragEvent, data || this._dragData)
    }

    this._raise('mouseup', e, {}, data)

    if (this._mouseTarget === e.target && !this._dragEvent) {
      this._onClick(e, data)
    }

    this._mouseButton = null
    this._mouseTarget = null
    this._dragEvent = null
    this._dragStartX = null
    this._dragStartY = null
    this._dragData = null
  }

  _onClick = (e, data) => {
    this._raise('click', e, {}, data)
  }

  _onMouseMove = (e, data) => {
    if (this._mouseButton !== null) {
      if (this._dragStartX === null && this._dragStartY === null) {
        this._dragStartX = e.clientX
        this._dragStartY = e.clientY
      }

      if (
        !this._dragEvent &&
        (Math.abs(e.clientX - this._dragStartX) > this._dragTolerance ||
          Math.abs(e.clientY - this._dragStartY) > this._dragTolerance)
      ) {
        this._dragEvent = {
          element: {
            node: e.target,
            width: e.target.offsetWidth,
            height: e.target.offsetHeight,
            originalPos: {
              x: e.target.offsetLeft,
              y: e.target.offsetTop,
            },
            currentPos: {
              x: e.target.offsetLeft,
              y: e.target.offsetTop,
            },
          },
          start: {
            x: e.clientX,
            y: e.clientY,
          },
          current: {
            x: e.clientX,
            y: e.clientY,
          },
          delta: {
            x: 0,
            y: 0,
          },
        }

        this._raise('dragstart', e, this._dragEvent, data || this._dragData)
      }

      if (this._dragEvent) {
        this._dragEvent.delta.x = e.clientX - this._dragEvent.start.x
        this._dragEvent.delta.y = e.clientY - this._dragEvent.start.y
        this._dragEvent.current.x = e.clientX
        this._dragEvent.current.y = e.clientY
        this._dragEvent.element.currentPos.x =
          this._dragEvent.element.originalPos.x + this._dragEvent.delta.x
        this._dragEvent.element.currentPos.y =
          this._dragEvent.element.originalPos.y + this._dragEvent.delta.y

        this._raise('drag', e, this._dragEvent, data || this._dragData)
      }
    } else {
      this._raise('mousemove', e, {}, data)
    }
  }

  _onContextMenu = (e) => {
    e.preventDefault()
  }
}

export default EventsHandler
